import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';
import { ApiResponse } from 'src/app/models/IApiResponse';

@Injectable({
  providedIn: 'root'
})
export class MobileVehicleRelocationPhotosService {

  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Upload vehicle relocation photos
   *
   * @param formData
   * @param chassis_no
   * @param log_id
   * @param txn_type
   * @returns Observable<any>
   */
  uploadPhotos(formData:FormData,chassis_no: string|null,log_id: string|null,txn_type: string|null):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/upload-vehicle-relocation-photos`;

    formData.append('chassis_no', chassis_no ?? '');
    formData.append('log_id', log_id ?? '');
    formData.append('txn_type', txn_type ?? '');

    return this.http.post(apiURL,formData).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get photos taken when transferring vehicle
   * @param log_id
   * @returns Observable<ApiResponse>
   */
  getVehicleTransferringPhotos(log_id: string|null): Observable<ApiResponse>
  {
    let apiURL:string=`${this.baseURL}/v1/get-transferred-vehicle-photos/${log_id}`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get photos take when receiving transferred vehicle
   * @param log_id
   * @returns Observable<ApiResponse>
   */
  getVehicleReceivingPhotos(log_id: string|null): Observable<ApiResponse>
  {
    let apiURL:string=`${this.baseURL}/v1/get-received-vehicle-photos/${log_id}`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }
}
